import { t } from 'i18next';

// Matches the deployed IpRangePolicy contract, which is IPv4-only:
//   - IPv4, optionally with a `*` wildcard in any octet (e.g. 192.168.1.42, 192.168.*.42)
//   - IPv4 with a CIDR suffix whose prefix length is /0, /8, /16, /24 or /32 (e.g. 192.168.1.0/24)
// IPv6 is intentionally not supported by the backend.

// A single octet: 0-255.
const v4Octet = '(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)';
// A plain IPv4 address: four octets.
const ipv4 = `(${v4Octet}\\.){3}${v4Octet}`;
// An octet or a `*` wildcard.
const v4OctetOrWildcard = `(${v4Octet}|\\*)`;
// An IPv4 address that may use `*` wildcards in any octet (mutually exclusive with CIDR).
const ipv4WithWildcard = `(${v4OctetOrWildcard}\\.){3}${v4OctetOrWildcard}`;
// CIDR prefix length, restricted to octet boundaries: /0, /8, /16, /24, /32.
const cidrSuffix = '/(0|8|16|24|32)';

const ipRangeRegex = new RegExp(`^(${ipv4WithWildcard}|${ipv4}${cidrSuffix})$`);

const isValidIpRange = (value: string) => ipRangeRegex.test(value);

export function validateIpRange(value: string, values: Set<string>) {
  if (!isValidIpRange(value)) {
    return t('manager.webcastSetup.eventAccess.accessControlMethods.ipRange.errorMessages.noValidIp');
  }

  if (values.has(value)) {
    return t('manager.webcastSetup.eventAccess.accessControlMethods.ipRange.errorMessages.duplicateIp');
  }
}
